<template>
  <Bmap ref="bmap" :initPoint="initPoint" :revisability="false" @mapHandler="mapHandler" />
</template>

<script>
import Bmap from '@/components/bmap';
import { getSmokePuff } from '@/api/devices';
import { stateMapMarker } from '@/utils/dict';
import { isLocal } from '@/utils/utils';

export default {
  name: 'PuffMap',
  data() {
    return {
      initPoint: {}
    };
  },
  components: { Bmap },
  methods: {
    addPolygon(payload) {
      const BMap = window.BMap;
      if (!BMap) return;
      let puffDataMap = new Map();
      for (let i = 0, len = payload.length; i < len; i++) {
        const { color, coords } = payload[i];
        let point1 = new BMap.Point(coords[0][0], coords[0][1]);
        let points = [];
        if (puffDataMap.has(color)) {
          points = puffDataMap.get(color);
        }
        points.push(point1);
        puffDataMap.set(color, points);
      }
      for (let key of puffDataMap.keys()) {
        const options = {
          // eslint-disable-next-line no-undef
          size: BMAP_POINT_SIZE_NORMAL,
          // eslint-disable-next-line no-undef
          shape: BMAP_POINT_SHAPE_CIRCLE,
          color: key
        };
        const colorPoints = new BMap.PointCollection(puffDataMap.get(key), options);
        this.$refs['bmap'].bmap.addOverlay(colorPoints);
      }
    },
    addLabel({ sn, center }) {
      this.$refs['bmap'].bmap.addOverlay(
        // eslint-disable-next-line no-undef
        new BMap.Label(sn, {
          // eslint-disable-next-line no-undef
          position: new BMap.Point(center.xcoord, center.ycoord),
          // eslint-disable-next-line no-undef
          offset: new BMap.Size(-30, -30)
        })
      );
    },
    mapHandler(theme) {
      this.$nextTick(async () => {
        const BMap = window.BMap;
        const res = await getSmokePuff(this.$route.params.sn);
        if (!res.data) {
          this.$message({
            type: 'warning',
            message: '暂无数据'
          });
          return;
        }
        const { center } = res.data[this.$route.params.sn] || {};

        let max = 17;
        const min = 3;

        if (isLocal()) {
          max = 13;
        }

        this.$refs['bmap'].bmap.setMinZoom(min);
        this.$refs['bmap'].bmap.setMaxZoom(max);

        if (center) {
          this.initPoint = new BMap.Point(center.xcoord, center.ycoord);
          this.$refs['bmap'].bmap.centerAndZoom(this.initPoint, max - 1);
        }
        if (theme) this.$refs['bmap'].bmap.setMapStyleV2({ styleJson: theme });
        for (let sn in res.data) {
          const { center, payload } = res.data[sn] || {};
          if (!center) return;
          // 在地图添加sn标签
          this.addLabel({ sn, center });
          // 有payload时显示扩散模型，没有时显示标记
          if (Array.isArray(payload) && payload.length) {
            this.addPolygon(payload);
          } else {
            const marker = new BMap.Marker(new BMap.Point(center.xcoord, center.ycoord), {
              icon: new BMap.Icon(stateMapMarker[0], new BMap.Size(32, 32))
            });
            this.$refs['bmap'].bmap.addOverlay(marker);
          }
        }
        // 关闭加载动画
        this.$emit('closeLoading');
      });
    }
  }
};
</script>
